import { combineEpics } from 'redux-observable';
import { filter, map, mapTo, switchMap } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { catchAxiosError, catchUnauthorizedError, createEpic$ } from 'lib/store';
import { storeTokenResponse$ } from 'services/auth';
import { notificationError } from 'store/notifications';
import { AuthAction, authError, authResponse, authSuccess } from './actions';

const authErrorEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(AuthAction.Error)),
    map(() =>
      notificationError({
        caption: 'Authentication failed',
        message: 'Invalid username or password',
      }),
    ),
  ),
);

const authRequestEpic$ = createEpic$(({ action$, getSigninToken$ }) =>
  action$.pipe(
    filter(isOfType(AuthAction.Request)),
    switchMap(action =>
      getSigninToken$(action.payload.userName, action.payload.password).pipe(
        map(authResponse),
        catchAxiosError(authError),
        catchUnauthorizedError(authError),
      ),
    ),
  ),
);

const authLoginResponseEpic$ = createEpic$(({ action$ }) =>
  action$.pipe(
    filter(isOfType(AuthAction.Response)),
    switchMap(action => storeTokenResponse$(action.payload)),
    mapTo(authSuccess()),
  ),
);

export default combineEpics(authErrorEpic$, authRequestEpic$, authLoginResponseEpic$);
